// src/components/shop/ProductTabs.jsx

import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ProductTabDescription from './ProductTabDescription';
import ProductTabSpecification from './ProductTabSpecification';
// import ProductTabReviews from './ProductTabReviews';

class ProductTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 'description',
    };
  }

  setTab = (newTab) => {
    this.setState({ currentTab: newTab });
  };

  render() {
    const { withSidebar, product } = this.props;
    const { currentTab } = this.state;

    const classes = classNames('product-tabs', {
      'product-tabs--layout--sidebar': withSidebar,
    });

    // Преобразуем новый формат attributes (object) в массив {name, value}
    const specs = product.attributes
      ? Object.entries(product.attributes).map(([name, value]) => ({
          name,
          value,
        }))
      : [];

    const tabs = [
      {
        key: 'description',
        title: 'Описание',
        content: <ProductTabDescription desc={product.description} />,
      },
      {
        key: 'specification',
        title: 'Характеристики',
        content: <ProductTabSpecification characteristics={specs} />,
      },
      // { key: 'reviews', title: 'Отзывы', content: <ProductTabReviews /> },
    ];

    const tabsButtons = tabs.map((tab) => {
      const btnClass = classNames('product-tabs__item', {
        'product-tabs__item--active': currentTab === tab.key,
      });
      return (
        <button
          key={tab.key}
          type="button"
          className={btnClass}
          onClick={() => this.setTab(tab.key)}
        >
          {tab.title}
        </button>
      );
    });

    const tabsContent = tabs.map((tab) => {
      const paneClass = classNames('product-tabs__pane', {
        'product-tabs__pane--active': currentTab === tab.key,
      });
      return (
        <div key={tab.key} className={paneClass}>
          {tab.content}
        </div>
      );
    });

    return (
      <div className={classes}>
        <div className="product-tabs__list">{tabsButtons}</div>
        <div className="product-tabs__content">{tabsContent}</div>
      </div>
    );
  }
}

ProductTabs.propTypes = {
  withSidebar: PropTypes.bool,
  product: PropTypes.shape({
    description: PropTypes.string,
    // attributes — объект вида { "Название характеристики": "Значение", ... }
    attributes: PropTypes.objectOf(PropTypes.string),
  }).isRequired,
};

ProductTabs.defaultProps = {
  withSidebar: false,
};

export default ProductTabs;
